import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useAppContext } from './appprovider';
import { canAccessBilling } from './Instructor/services/instructorPortalAccess';
import styled from 'styled-components';
import PackageDialog from "../components/Instructor/course/packagedialog";
import { Btn } from "./Instructor/ui/primitives";
import CircularProgress from '@mui/material/CircularProgress';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import axios from 'axios';
import DashboardNavbar from "./Instructor/dashboardNavbar"

// Styled button component (reference danger button for logout)
const StyledButton = styled.button`
  display: block;
  margin: 16px auto 0;
  height: 34px;
  padding: 0 18px;
  background: ${({ theme }) => theme.danger};
  color: #fff;
  border: none;
  border-radius: ${({ theme }) => theme.rMd};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontBody};
  font-size: 11.5px;
  font-weight: 650;
  outline: none;
  transition: background-color 0.15s ease;

  &:hover {
    background: ${({ theme }) => `color-mix(in oklch, ${theme.danger} 82%, #000)`};
  }
`;

const ProfileCard = styled.div`
  background: ${({ theme }) => theme.surface};
  border: ${({ theme }) => theme.cardBorder};
  border-radius: ${({ theme }) => theme.rLg};
  box-shadow: ${({ theme }) => theme.cardShadow};
  padding: 22px;
  text-align: center;
  width: 320px;
  max-width: 100%;
  height: auto;
  margin: 20px auto;
`;

const ProfileName = styled.h2`
  font-family: ${({ theme }) => theme.fontHead};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -.01em;
  color: ${({ theme }) => theme.text};
  margin: 0;
`;

const ProfileEmail = styled.p`
  font-size: ${({ theme }) => theme.fsSm};
  color: ${({ theme }) => theme.textMuted};
  margin: 6px 0 0;
`;

export default function SignOut() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { setUserId, setPackageDetails, entitlements } = useAppContext();
  const userId = localStorage.getItem('userId');
  const userType = localStorage.getItem('userType');
  const apiUrl = process.env.REACT_APP_API_URL;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);
  const [accountNumber, setAccountNumber] = useState('');
  const [routingNumber, setRoutingNumber] = useState('');
  const [openAccountDialog, setOpenAccountDialog] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [userDetails, setUserDetails] = useState({ name: '', email: '', userType: '' });
  const menuItems = [ { "title": "Organisation", "link": "/Portal/Instructor/organisation" },
    { "title": "Profile", "link": "/Portal/Instructor/profile" },
    { "title": "Package", "link": "/Portal/Instructor/packageDetails" },
    { "title": "Register", "link": "/Portal/Instructor/Register" }];

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  function handleSignOut() {
    setUserId(null);
    setPackageDetails(null);
    signOut();
    navigate("/login", { replace: true });
  }

  // Open dialog box
  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  useEffect(() => {
    fetchAccountDetails();
  }, []);

  async function fetchAccountDetails() {
    setIsLoading(true);
    try {
      // Fetch user details
      const userResponse = await axios.get(`${apiUrl}/api/users/instructor/${userId}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        },
      });
      if (userResponse.data) {
        setUserDetails({
          name: userResponse.data.firstName + ' ' + userResponse.data.lastName,
          email: userResponse.data.email,
          userType: userResponse.data.userType
        });
      }
      //fetch account details
      if(userType === '4')
      {
      const response = await axios.get(`${apiUrl}/api/accountdetails/${userId}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        },
      });
      if (response.data) {
        setAccountDetails(response.data);
        setAccountNumber(response.data.accountNumber);
        setRoutingNumber(response.data.routingNumber);
      } else {
        setOpenAccountDialog(true);
      }
    }
    } catch (error) {
      console.error('Error fetching account details:', error);
      setOpenAccountDialog(true);
    } finally {
      setIsLoading(false);
    }
  }

  const handleAccountDialogClose = () => {
    setOpenAccountDialog(false);
  };

  const handleAccountSubmit = async () => {
    setLoadingSubmit(true);
    const data = {
      accountNumber,
      routingNumber,
      userId,
      email: userDetails.email
    };

    try {
      let response;
      if (accountDetails) {
        response = await axios.put(`${apiUrl}/api/accountdetails/${userId}`, data, {
          headers: {
            'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
          },
        });
      } else {
        response = await axios.post(`${apiUrl}/api/accountdetails`, data, {
          headers: {
            'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
          },
        });
      }
      console.log('Account details submitted successfully:', response.data);
      setAccountDetails(response.data);
      handleAccountDialogClose();
    } catch (error) {
      console.error('Error submitting account details:', error);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <>
    <DashboardNavbar menuItems={menuItems} />
    <div style={{ height: '100%' }}>
      {canAccessBilling(entitlements) && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Btn onClick={handleDialogOpen}>Upgrade Plan</Btn>
        </div>
      )}
      <PackageDialog open={dialogOpen} handleClose={() => setDialogOpen(false)} />
      {userType === '2' && (
        <ProfileCard>
          <ProfileName>Hi Admin</ProfileName>
        </ProfileCard>
      )}
      <ProfileCard>
        {userType === '2' && userDetails.userType === 4 && (
          <ProfileEmail>Logged in as</ProfileEmail>
        )}
        <ProfileName>Name: {userDetails.name}</ProfileName>
        <br />
        <ProfileEmail>Email: {userDetails.email}</ProfileEmail>
        {accountDetails && (
          <>
            <ProfileEmail>Account Number: {accountDetails.accountNumber}</ProfileEmail>
            <ProfileEmail>Routing Number: {accountDetails.routingNumber}</ProfileEmail>
          </>
        )}
      </ProfileCard>
      <StyledButton onClick={handleSignOut}>Log out</StyledButton>

      <Dialog open={openAccountDialog} onClose={handleAccountDialogClose}>
        <DialogTitle>Enter Account Details</DialogTitle>
        <DialogContent>
          <TextField
            label="Account Number"
            variant="outlined"
            fullWidth
            margin="normal"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
          <TextField
            label="Routing Number"
            variant="outlined"
            fullWidth
            margin="normal"
            value={routingNumber}
            onChange={(e) => setRoutingNumber(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAccountDialogClose} color="secondary" disabled={loadingSubmit}>
            Cancel
          </Button>
          <Button onClick={handleAccountSubmit} color="primary" disabled={loadingSubmit}>
            {loadingSubmit ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
      
    </div>
    </>
  );
}
